import { useContext } from "react";
import {MobileLayoutContext} from '../contexts/MobileLayoutContext'; 

const useMobileLayoutNavigation = () => useContext(MobileLayoutContext);

export default useMobileLayoutNavigation;